mutation REORDER_FACILITY_MEDIA(
  $facilityId: UUID!,
  $mediaOrder: [MediaOrderInput!]!
) {
  reorderFacilityMedia(
    facilityId: $facilityId,
    mediaOrder: $mediaOrder
  ) {
    success
    error
    facilityMedia {
      id
      name
      displayOrder
      file
      isThumbnail
    }
  }
}
